// import {post, downFile, postfile} from './http'
import {post, downFile} from './http'
const baseUrl = '/api/admin/mktools/event'

// 查询活动基本简略信息
export const eventInfo = v => post(`${baseUrl}/getSimpleEventDetail`, v.data, v.success, v.error)

// 查询名单信息列表
export const getEenrolleventUserList = v => post(`${baseUrl}/getEenrolleventUserList`, v.data, v.success, v.error)

// 查询名单详情
export const getEventUserInfoDetail = v => post(`${baseUrl}/getEventUserInfoDetail`, v.data, v.success, v.error)

// 导出名单列表
export const exportEventUserList = v => downFile(`${baseUrl}/exportEventUserList`, v.data, v.success, v.error)

// 统计名单的各个状态的数量
export const statisticalUserNum = v => post(`${baseUrl}/statisticalUserNum`, v.data, v.success, v.error)

// 查询报名详情信息
export const getApplySetDetail = v => post(`${baseUrl}/getEventApplyDetail`, v.data, v.success, v.error)

// 新增或编辑报名信息
export const saveApplySet = v => post(`${baseUrl}/saveOrUpdateEventApply`, v.data, v.success, v.error)

// 保存新增编辑活动
export const saveEnrolleventinfo = v => post(`${baseUrl}/saveEnrolleventinfo`, v.data, v.success, v.error)

// 查询活动列表接口
export const getEnrolleventinfoList = v => post(`${baseUrl}/getEnrolleventinfoList`, v.data, v.success, v.error)

// 活动详情接口
export const getEnrolleventinfoDetail = v => post(`${baseUrl}/getEnrolleventinfoDetail`, v.data, v.success, v.error)

// 保存新增或编辑活动接口V2 /api/admin/mktools/event/saveEnrolleventinfoV2
export const saveEnrolleventinfoV2 = v => post(`${baseUrl}/saveEnrolleventinfoV2`, v.data, v.success, v.error)

// 查询活动详情接口V2 /api/admin/mktools/event/getEnrolleventinfoDetailV2
export const getEnrolleventinfoDetailV2 = v => post(`${baseUrl}/getEnrolleventinfoDetailV2`, v.data, v.success, v.error)

// 删除活动海报
export const deleteEventPoster = v => post(`${baseUrl}/deleteEventPoster`, v.data, v.success, v.error)

// 查询海报列表
export const getEnrolleventPosterList = v => post(`${baseUrl}/getEnrolleventPosterList`, v.data, v.success, v.error)

// 保存新增或编辑活动海报
export const saveOrUpdateEventPoster = v => post(`${baseUrl}/saveOrUpdateEventPoster`, v.data, v.success, v.error)

// 查询单个海报详情
export const getEventPosterInfoDetail = v => post(`${baseUrl}/getEventPosterInfoDetail`, v.data, v.success, v.error)

// 导出订单列表
export const exportOrderList = v => downFile(`${baseUrl}/exportOrderList`, v.data, v.success, v.error)

// 查询订单列表
export const getEenrolleventOrderList = v => post(`${baseUrl}/getEenrolleventOrderList`, v.data, v.success, v.error)

// 查询订单详情
export const getEventOrderDetail = v => post(`${baseUrl}/getEventOrderDetail`, v.data, v.success, v.error)

// 作废订单
export const updateCancelledEventorder = v => post(`${baseUrl}/updateCancelledEventorder`, v.data, v.success, v.error)

// 审核通过和拒绝订单
export const updateEventorderStatus = v => post(`${baseUrl}/updateEventorderStatus`, v.data, v.success, v.error)


// 发送消息通知
export const sendMessageNotice = v => post(`${baseUrl}/sendMessageNotice`, v.data, v.success, v.error)


// 导出参与签到用户Excel
export const exportTicktuserList = v => downFile(`${baseUrl}/exportTicktuserList`, v.data, v.success, v.error)

// 查询名单信息列表
export const getTicketuserList = v => post(`${baseUrl}/getTicketuserList`, v.data, v.success, v.error)

// 修改签到状态
export const updatEventticketUserStatus = v => post(`${baseUrl}/updatEventticketUserStatus`, v.data, v.success, v.error)

// 统计订单数
export const statisticalOrders = v => post(`${baseUrl}/statisticalOrders`, v.data, v.success, v.error)

// 统计签到数据
export const statisticalSignNum = v => post(`${baseUrl}/statisticalSignNum`, v.data, v.success, v.error)

// 修改活动
export const updateEnrolleventinfoStatus = v => post(`${baseUrl}/updateEnrolleventinfoStatus`, v.data, v.success, v.error)

// 取消活动详情
export const getCancelEnrolleventinfo = v => post(`${baseUrl}/getCancelEnrolleventinfo`, v.data, v.success, v.error)

// 取消活动
export const cancelEventinfoByHost = v => post(`${baseUrl}/cancelEventinfoByHost`, v.data, v.success, v.error)

// 推荐活动/取消推荐
export const setEventRecommend = v => post(`${baseUrl}/setEventRecommend`, v.data, v.success, v.error)

// 评论列表 /api/admin/fans/findAllComment
export const findAllComment = v => post(`/api/admin/fans/findAllComment`, v.data, v.success, v.error)

// 评论详情 /api/admin/fans/findCommentDetail
export const findCommentDetail = v => post(`/api/admin/fans/findCommentDetail`, v.data, v.success, v.error)

// 提交评论回复 /api/admin/fans/uploadReplyCommentInfo
export const uploadReplyCommentInfo = v => post(`/api/admin/fans/uploadReplyCommentInfo`, v.data, v.success, v.error)

// 删除评论 /api/admin/fans/deleteCommentInfo
export const deleteCommentInfo = v => post(`/api/admin/fans/deleteCommentInfo`, v.data, v.success, v.error)
